import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
Chart.plugins.unregister(ChartDataLabels)
Chart.defaults.global.defaultFontSize = 11
Chart.defaults.global.defaultFontFamily = "Helvetica"

import { minutesToHours, formatNumber, formatToCurrency, isBlank } from '../commons.js'

import ApplicationController from './application_controller.js'
export default class ChartsController extends ApplicationController {

  connect() {
    this.draw()
  }

  draw() {
    var data = JSON.parse(this.element.dataset.chartData)
    for (const [key, value] of Object.entries(data['flags'])) {
      switch (key) {

        case 'y_axis_format':
          switch (value) {
            case 'hours':
              data.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return minutesToHours(value, true)
              }
              break

            case 'currency':
              data.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatToCurrency(value)
              }
              break

            case 'number':
              data.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatNumber(value)
              }
              break
          }
          break

        case 'tooltips_format':
          switch (value) {
            case 'hours':
              data.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                  var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                  return `${data.labels[tooltipItem.index]} : ${minutesToHours(value)}`
                }
              }
              break

            case 'currency':
              data.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                  var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                  return formatToCurrency(value)
                }
              }
              break

            // case 'percentage':
            //   data.options.tooltips.callbacks = {
            //     label: function (tooltipItem, data) {
            //       var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
            //       return `${value * 100}%`
            //     }
            //   }
            //   break
          }
          break

        case 'use_ChartDataLabels':
          data.plugins = [ChartDataLabels]
          data.options.plugins = {
            datalabels: {
              formatter: function (value, ctx) {
                let datasets = ctx.chart.data.datasets;
                if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                  let sum = datasets[0].data.reduce((a, b) => a + b, 0)
                  let percentage = Math.round((value / sum) * 100)
                  if (percentage > 10)
                    return percentage + '%'
                  else
                    return ''
                } else {
                  return percentage
                }
              },
              color: "#000"
            }
          }
          break
      }
    } // for const loop

    if (data.custom.type === "daily") {
      data.options.onClick = (e) => {
        const nearest = this.chart.getElementsAtEventForMode(e, 'nearest', { intersect: false, axis: 'x' });
        const index = nearest[0]._index
        if (index >= 0) {
          const date = data.custom.s0_values[index]
          const user_id = document.getElementById("user_id").value // Utilisateur sélectionné dans la saisie des temps
          if (!isBlank(user_id)) {
            const filter_event = new CustomEvent("@daily-filter#refresh", { detail: { daily_chart_date: date }, bubbles: true });
            e.target.dispatchEvent(filter_event)
            const picker_event = new CustomEvent("@flat-picker#changeDate", { detail: date, bubbles: true });
            e.target.dispatchEvent(picker_event)
          }
        }
      }
    }
    this.chart = new Chart(this.element, data)
  }

}